import { get_token } from "@/router";
import HomeNavBar from '@/components/HomeNavBar/HomeNavBar.vue';
import { view_profile_product,format_price } from "@/views/Marketplace/marketplace_helpers";
import { view_profile as view_profile_helper } from "@/views/home/home_helper.js";


export default {
    name: "UnifiedSearchResults",
    components: {
        HomeNavBar,
    },

    mounted() {
        this.token_exists = get_token();
    },
    data() {
        return ({
            query: "",
            current_user_id: localStorage.getItem('user_id') || '',
            isLoading: false,
            activeTab: "all",
            results: {
                products: [],
                reports: [],
                companies: [],
                profiles: [],
                portals: []
            },
            tabs: [
                { id: "all", label: "All" },
                { id: "products", label: "Products" },
                { id: "services", label: "services" },
                { id: "reports", label: "Reports" },
                { id: "businesses", label: "Business" },
                { id: "profiles", label: "People" },
            ]
        });
    },
    watch: {
        '$route.query.q': {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.query = newVal;
                    this.fetch_results();
                }
            }
        }
    },
    computed: {
        has_results() {
            return (
                this.results.products?.length ||
                this.results.reports?.length ||
                this.results.companies?.length ||
                this.results.profiles?.length
            );
        },
    active_tab_has_results() {
        const resolvers = {
            all: () => this.has_results,
            products: () => this.products_only?.length,
            services: () => this.services_only?.length,
            reports: () => this.results.reports?.length,
            businesses: () => this.results.companies?.length,
            profiles: () => this.results.profiles?.length
        };

        const fn = Reflect.get(resolvers, this.activeTab);
        return fn ? Boolean(fn()) : false;
        },

        visible_tabs() {
            return this.tabs.filter(tab => {
            if ((tab.id === 'products' || tab.id === 'services') &&
                !this.client_features?.show_marketplace) {
                return false;
            }
            return true;
            });
        },
        products_only() {
            return this.results.products?.filter(p => p.product_type?.name !== 'service') || [];
        },

        services_only() {
            return this.results.products?.filter(p => p.product_type?.name === 'service') || [];
        }
    },
    inject: ['client_features'],

    methods: {
        format_price,

        fetch_results() {
            this.isLoading = true;
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/global_search_api/`,
                type: 'POST',
                headers: {
                    Authorization: `Token ${get_token()}`,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify({ query: this.query }),
                success: (response) => {
                    if (response.status === 'success') {
                        this.results = response.data;
                        this.get_rating();
                    }
                },
                error: (err) => {
                    console.error("Search failed", err);
                },
                complete: () => {
                    this.isLoading = false;
                }
            });
        },
        format_date(dateString) {
            if(!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString();
        },
        strip_html(html) {
            if (!html) return '';
            let text = html.replace(/<[^>]*>/g, '');
            return text;
        },
        displayed_description(report) {
            if (!report.description) return '';
            let text = report.description.replace(/<[^>]*>/g, '');
            return text.length > 100 ? text.substring(0, 100) + '...' : text;
        },
        view_product_details(product){
            view_profile_product(this.$router, product);
        },
        view_report(report) {
            window.location = `/home?report_id=${report.id}`;
        },
        view_personal_profile(userId) {
            view_profile_helper(this.$router, { id: userId });
        },
         view_profile(profile) {
        view_profile_helper(this.$router, profile);
    },
        get_rating() {
            if (!this.results.companies) return;

            this.results.companies.forEach(company => {
                const profileId = company.base_profile?.id;
                if (!profileId) return;

                $.ajax({
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/retrieve_profile_rating/`,
                    type: 'POST',
                    headers: {
                        Authorization: `Token ${get_token()}`,
                        'Content-Type': 'application/json',
                    },
                    data: JSON.stringify({ profile_id: profileId }),
                    success: (response) => {
                        if (response.status === 'success') {
                            // Store rating info in the company object
                            company.rating = Math.round(response.data.average_rating * 2) / 2; // round to nearest 0.5
                            company.totalRatings = response.data.total_count;
                            company.allRatings = response.data.ratings;
                        }
                    }
                });
            });
        },
        follow_profile(item) {
            const base_profile_id = item.base_profile?.id;
            if (!base_profile_id) return;

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/follow_profile/`,
                type: "POST",
                headers: {
                    Authorization: `Token ${get_token()}`,
                    "Content-Type": "application/json",
                },
                data: JSON.stringify({ target_base_profile_id: base_profile_id }),
                success: (response) => {
                    if (response.status === "success") {
                        item.is_following = response.is_following;
                    }
                }
            });
        },        

    }
};
